import { useCallback, useMemo } from "react";
import { useMutation } from "@edreamsodigeo/frontend-api-client";
import { useLogFrontendApiError } from "@edreamsodigeo/frontend-core";
import { GENERATE_TRIP_TOKEN } from "../../../graphql/mutations";
const useGenerateTripToken = () => {
  const queryResult = useMutation(GENERATE_TRIP_TOKEN);
  const {
    data,
    errors,
    loading,
    mutate
  } = queryResult;
  const generateTokenMutate = useCallback(({
    bookingId,
    email
  }) => {
    mutate({
      bookingId,
      email
    });
  }, [mutate]);
  useLogFrontendApiError(queryResult);
  return useMemo(() => ({
    data,
    loading,
    errors,
    mutate: generateTokenMutate
  }), [data, loading, errors, generateTokenMutate]);
};
export default useGenerateTripToken;